require('./chargebeeKinderlyPlugin/frontend/index.js');
require('./courseBookings/frontend/index.js');
require('./dashboardTiles/frontend/index.js');
require('./scorm/frontend/index.js');
